module.exports = __webpack_public_path__ + "img/latest_update.22aadb0e.svg";